enum ContactMethodType {
    None,
    Email,
    MobilePhone,
    Landline
}

export default ContactMethodType
